import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';

import { PredavaciPopisService } from './predavaci-popis.service';
import { PartneriPopisService } from './../partneri-popis/partneri-popis.service';

import * as toastr from 'toastr';
import * as alertify from 'alertify.js';

import { PredavacPopis } from './predavaci-popis';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';

import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

import { AppConfig } from '../../../config';
@Component({
  selector: 'app-predavaci-popis',
  templateUrl: './predavaci-popis.component.html',
  styleUrls: ['./predavaci-popis.component.css'],
  providers: [PredavaciPopisService, PartneriPopisService]
})
export class PredavaciPopisComponent implements OnInit {

  sviPredavaci = [];
  predavacOptions: DataTables.Settings = {};
  predavacTrigger: Subject<PredavacPopis> = new Subject();

  predavacForma: FormGroup;
  predavacEditForma: FormGroup;

  sviPartneri: any[];
  filee:any;

  URL: any = AppConfig.IPfile;
  postojiSlika: boolean = false;
  accessToken: any = localStorage.getItem('tokenSql');
  ud_nazivdokumenta: string;
  idkorisnik: string;

  constructor(
    private _fb: FormBuilder,
    public _partneriPopisService: PartneriPopisService,
    private _predavaciPopisService: PredavaciPopisService,
    public _router: Router,
    private _sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.dohvatiPopisPredavaca();
    this.partneriPopis();
    //Tablica početak
    this.predavacOptions = {
      pagingType: 'full_numbers',
      pageLength: 50,
      responsive: true,
      columnDefs: [{
          targets: 'no-sort',
          orderable: false
      }],
      retrieve: true
  };
  //Tablica kraj
  this.predavacForma = this._fb.group({
    imeprezime: [''],
    spol: [''],
    oib: [''],
    email: [''],
    telefon: [''],
    adresa: [''],
    mjesto: [''],
    partnerId: [''],
    partnerNaziv: [''],
    aktivan: [''],
    opis: ['']
  });
  this.predavacEditForma = this._fb.group({
    idkorisnik: [''],
    imeprezime: [''],
    spol: [''],
    oib: [''],
    email: [''],
    telefon: [''],
    adresa: [''],
    mjesto: [''],
    partnerId: [''],
    partnerNaziv: [''],
    aktivan: [''],
    opis: ['']
  });
  }

  pripremiPodatke(predavac){
    // console.log(predavac);
    this.predavacEditForma = this._fb.group({
      idkorisnik: predavac['id'],
      imeprezime: predavac['imeprezime'],
      spol: predavac['spol'],
      oib: predavac['oib'],
      email: predavac['email'],
      telefon: predavac['telefon'],
      adresa: predavac['adresa'],
      mjesto: predavac['mjesto'],
      partnerId: predavac['partnerId'],
      partnerNaziv: predavac['partnerNaziv'],
      aktivan: predavac['aktivan'],
      opis: predavac['opis'],
      ud_nazivdokumenta: predavac['ud_nazivdokumenta']
    });
    if(this.predavacEditForma.value.ud_nazivdokumenta){
      this.postojiSlika = true;
      this.ud_nazivdokumenta = this.predavacEditForma.value.ud_nazivdokumenta;
      this.idkorisnik = this.predavacEditForma.value.idkorisnik;
    } else {
      this.postojiSlika = false;
    }
  }

  uredi(predavac){
    let objektZaSlanje = {
      'idkorisnik': predavac['idkorisnik'],
      'imeprezime': predavac['imeprezime'],
      'spol': predavac['spol'],
      'oib': predavac['oib'],
      'email': predavac['email'],
      'telefon': predavac['telefon'],
      'adresa': predavac['adresa'],
      'mjesto': predavac['mjesto'],
      'partner': predavac['partnerId'],
      'aktivan': predavac['aktivan'],
      'opis': predavac['opis']
    }
    // console.log(objektZaSlanje);
      this._predavaciPopisService.urediPredavaca(objektZaSlanje).subscribe(res => {
        if(res.success == true){
          toastr.success("Uspješno uređivanje!");
          this.dohvatiPopisPredavaca();
        } else {
           toastr.error("Neuspješno uređivanje!");
        }
      });
   
  }

  spremiPredavaca(predavacForma){
    let objektZaSlanje = {
      'imeprezime': predavacForma['imeprezime'],
      'spol': predavacForma['spol'],
      'oib': predavacForma['oib'],
      'email': predavacForma['email'],
      'telefon': predavacForma['telefon'],
      'adresa': predavacForma['adresa'],
      'mjesto': predavacForma['mjesto'],
      'partner': predavacForma['partnerId'],
      'opis': predavacForma['opis']
    };
    // console.log(objektZaSlanje);
    if(predavacForma['imeprezime'] && predavacForma['spol']){
      this._predavaciPopisService.noviPredavac(objektZaSlanje).subscribe(res => {
        if(res.success == true){
          toastr.success("Uspješno dodan predavač!");
          $('#predavaciTablica').DataTable().clear();
          $('#predavaciTablica').DataTable().destroy();
          this.dohvatiPopisPredavaca();
        } else {
           toastr.error("Neuspješno spremanje!");
        }
      });
    } else {
       toastr.error("Unesite potrebne podatke!");
    } 
  }

  dohvatiPopisPredavaca(){
    this.sviPredavaci = [];
    this._predavaciPopisService.dohvatiPredavace({'idkorisnik': localStorage.getItem('userId'), 'admin': localStorage.getItem('vrsta')}).subscribe(res => {
      // console.log(res);
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
          this.sviPredavaci.push({
            'id': res.data[i]['idkorisnik'],
            'imeprezime': res.data[i]['ko_imeiprezime'],
            'spol': res.data[i]['ko_spol'],
            'oib': res.data[i]['ko_oib'],
            'email': res.data[i]['ko_email'],
            'telefon': res.data[i]['ko_telefon'],
            'adresa': res.data[i]['ko_adresa'],
            'mjesto': res.data[i]['ko_grad'],
            'partnerId': res.data[i]['partner_idpartner'],
            'partnerNaziv': res.data[i]['pa_nazivtvrtke'],
            'aktivan': res.data[i]['ko_aktivan'],
            'opis': res.data[i]['ko_opis'],
            'ud_nazivdokumenta': res.data[i]['ud_nazivdokumenta'],
            'iduploaddokument': res.data[i]['iduploaddokument']
          });
          this.predavacTrigger.next();
        }
      } else {
        toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

  //Autocomplete
  partneriPopis(){
    this.sviPartneri = [];
    this._partneriPopisService.dohvatiPartnere({}).subscribe(res => {
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
          this.sviPartneri.push({
            'id': res.data[i]['idpartner'],
            'nazivtvrtke': res.data[i]['pa_nazivtvrtke'],
            'oib': res.data[i]['pa_oib'],
            'email': res.data[i]['pa_email'],
            'telefon': res.data[i]['pa_telefon'],
            'ulica': res.data[i]['pa_ulica'],
            'grad': res.data[i]['pa_grad'],
            'aktivan': res.data[i]['pa_aktivan']
          });
        }
      } else {
         toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

  autocompleListFormatter = (data: any) : SafeHtml => {
    let html = `<span>${data.nazivtvrtke}</span>`;
    return this._sanitizer.bypassSecurityTrustHtml(html);
  }

  traziPartnera(e){
    this.predavacForma.value.partnerId = e.id;
  }

  traziPartneraEdit(e){
    this.predavacEditForma.value.partnerId = e.id;
  }

  fileChange(event){
    //console.log(event)
    this.filee = event.target.files;
    if(this.filee != null || this.filee != undefined){
      let formData:FormData = new FormData();
      formData.append('nazivslike', this.filee[0].name);
      formData.append('datoteka', this.filee[0], this.filee[0].name);
      formData.append('nazivtablice', 'slikapredavaca');
      formData.append('idkorisnik', this.predavacEditForma.value.idkorisnik);
      this._predavaciPopisService.uploadPredavac(formData).subscribe(res => {
        if(res.success == true){
          toastr.success("Uspješno dodana slika!");
          this.ud_nazivdokumenta = event.target.files[0].name;
          this.filee = null;
          document.getElementById("upload-modal").click();
          this.dohvatiPopisPredavaca();
        } else {
          toastr.error("Neuspješno spremanje!");
        }
      });
    }
  }

  brisanjeSlikePredavaca(predavac){
    let ovo = this;
    alertify
    .okBtn("Obriši")
    .cancelBtn("Odustani")
    .confirm("Jeste li sigurni da želite obrisati sliku predavača?", function (ev) {
      ev.preventDefault();
      if (alertify.success){
        ovo._predavaciPopisService.brisanje_slike_za_predavaca({'iduploaddokument': predavac.iduploaddokument}).subscribe(res => {
          if(res.success == true){
            ovo.dohvatiPopisPredavaca();
          } else {
             toastr.error("Neuspješno brisanje slike predavača!");
          }
        });
      }
    }, function(ev) {
      ev.preventDefault();
      toastr.info('Odustali ste od brisanja.');
    });
  }

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/predavaci-popis/predavaci-popis.component.ts